import './HomeGallery.css';

import { Link } from 'react-router-dom';
import { IcSharpArrowRightAlt } from '../../assets/icons/icons';

import image1 from '../../assets/images/home-gallery/1.jpg';
import image2 from '../../assets/images/home-gallery/2.jpg';
import image3 from '../../assets/images/home-gallery/3.jpg';
import image4 from '../../assets/images/home-gallery/4.jpg';
import image5 from '../../assets/images/home-gallery/5.jpg';
import image6 from '../../assets/images/home-gallery/6.jpg';
import image7 from '../../assets/images/home-gallery/7.jpg';
import image8 from '../../assets/images/home-gallery/8.jpg';
import image9 from '../../assets/images/home-gallery/9.jpg';
import image10 from '../../assets/images/home-gallery/10.jpg';
import image11 from '../../assets/images/home-gallery/11.jpg';
import image12 from '../../assets/images/home-gallery/12.jpg';
import image13 from '../../assets/images/home-gallery/13.jpg';
import image14 from '../../assets/images/home-gallery/14.jpg';
import image15 from '../../assets/images/home-gallery/15.jpg';

import { FullscreenImage } from '../../components';

export default function HomeGallery() {
  return (
    <div className='grid-container'>
      <div className='gird-item item-1'>
        <FullscreenImage image={image1} altText='Home-gallery-1' />
      </div>
      <div className='gird-item item-2'>
        <FullscreenImage image={image2} altText='Home-gallery-2' />
      </div>
      <div className='gird-item item-3'>
        <FullscreenImage image={image3} altText='Home-gallery-3' />
      </div>
      <div className='gird-item item-4'>
        <FullscreenImage image={image4} altText='Home-gallery-4' />
      </div>
      <div className='gird-item item-5'>
        <FullscreenImage image={image5} altText='Home-gallery-5' />
      </div>
      <div className='gird-item item-6'>
        <FullscreenImage image={image6} altText='Home-gallery-6' />
      </div>
      <div className='gird-item item-7'>
        <FullscreenImage image={image7} altText='Home-gallery-7' />
      </div>
      <div className='gird-item item-8'>
        <FullscreenImage image={image8} altText='Home-gallery-8' />
      </div>
      <div className='gird-item item-9'>
        <FullscreenImage image={image9} altText='Home-gallery-9' />
      </div>
      <div className='gird-item item-10'>
        <FullscreenImage image={image10} altText='Home-gallery-10' />
      </div>
      <div className='gird-item item-11'>
        <FullscreenImage image={image11} altText='Home-gallery-11' />
      </div>
      <div className='gird-item item-12'>
        <FullscreenImage image={image12} altText='Home-gallery-12' />
      </div>
      <div className='gird-item item-13'>
        <FullscreenImage image={image13} altText='Home-gallery-13' />
      </div>
      <div className='gird-item item-14'>
        <FullscreenImage image={image14} altText='Home-gallery-14' />
      </div>
      <div className='gird-item item-15'>
        <FullscreenImage image={image15} altText='Home-gallery-15' />
      </div>

      {/* <div className='gird-item item-2'>
        <img className='grid-image' src={image2} alt='' />
      </div>
      <div className='gird-item item-3'>
        <img className='grid-image' src={image3} alt='' />
      </div>
      <div className='gird-item item-4'>
        <img className='grid-image' src={image4} alt='' />
      </div>
      <div className='gird-item item-5'>
        <img className='grid-image' src={image5} alt='' />
      </div>
      <div className='gird-item item-6'>
        <img className='grid-image' src={image6} alt='' />
      </div>
      <div className='gird-item item-7'>
        <img className='grid-image' src={image7} alt='' />
      </div>
      <div className='gird-item item-8'>
        <img className='grid-image' src={image8} alt='' />
      </div>
      <div className='gird-item item-9'>
        <img className='grid-image' src={image9} alt='' />
      </div>
      <div className='gird-item item-10'>
        <img className='grid-image' src={image10} alt='' />
      </div>
      <div className='gird-item item-11'>
        <img className='grid-image' src={image11} alt='' />
      </div>
      <div className='gird-item item-12'>
        <img className='grid-image' src={image12} alt='' />
      </div>
      <div className='gird-item item-13'>
        <img className='grid-image' src={image13} alt='' />
      </div>
      <div className='gird-item item-14'>
        <img className='grid-image' src={image14} alt='' />
      </div>
      <div className='gird-item item-15'>
        <img className='grid-image' src={image15} alt='' />
      </div> */}

      <Link to='/gallery' className='link-gallery'>
        See All <IcSharpArrowRightAlt />
      </Link>
    </div>
  );
}

/*
TODO -
1. Change to use data from data file
*/
